export var PUBLISH_TO_GMB_STEPS;
(function (PUBLISH_TO_GMB_STEPS) {
    PUBLISH_TO_GMB_STEPS[PUBLISH_TO_GMB_STEPS["GMB_AUTH"] = 0] = "GMB_AUTH";
    PUBLISH_TO_GMB_STEPS[PUBLISH_TO_GMB_STEPS["PROPERTY_SELECTION"] = 1] = "PROPERTY_SELECTION";
    PUBLISH_TO_GMB_STEPS[PUBLISH_TO_GMB_STEPS["GMB_ERROR"] = 2] = "GMB_ERROR";
})(PUBLISH_TO_GMB_STEPS || (PUBLISH_TO_GMB_STEPS = {}));
